import React, { useState } from "react";
import { Alert, Badge, Modal, Spinner } from "react-bootstrap";
import { formatAngka } from "../../utils";

// Ambang yang dipakai backend untuk menandai sebuah order "berubah signifikan".
const AMBANG_PERSEN = 5;

const warnaDelta = (persen) => {
  const abs = Math.abs(Number(persen) || 0);
  if (abs >= 20) return "table-danger";
  if (abs >= AMBANG_PERSEN) return "table-warning";
  return "";
};

function ModalDryRun({ show, handleClose, indikator, hasil, loading, onUlang, error }) {
  const [Hari, setHari] = useState(30);

  const perbandingan = [...(hasil?.perbandingan || [])].sort(
    (a, b) => Math.abs(b.delta_persen || 0) - Math.abs(a.delta_persen || 0)
  );
  const berubah = Number(hasil?.order_berubah_signifikan || 0);

  return (
    <Modal show={show} onHide={handleClose} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "16px" }}>
          Dry-run &mdash; {indikator?.code}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-end mb-3" style={{ fontSize: "12px" }}>
          <div className="me-2">
            <label className="form-label fw-bold mb-1">Rentang (hari)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              style={{ width: 120, fontSize: "12px" }}
              value={Hari}
              onChange={(e) => setHari(e.target.value)}
            />
          </div>
          <button
            className="btn btn-sm btn-outline-primary mb-1"
            disabled={loading}
            onClick={() => onUlang(Number(Hari) || 30)}
          >
            Jalankan Ulang
          </button>
        </div>

        {loading && (
          <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
            <Spinner animation="border" size="sm" className="me-2" />
            Menghitung ulang order historis...
          </div>
        )}

        {error && error.length > 0 && (
          <Alert variant="danger" style={{ fontSize: "12px" }}>
            <ul className="mb-0 ps-3">
              {error.map((val, i) => (
                <li key={i}>{val}</li>
              ))}
            </ul>
          </Alert>
        )}

        {!loading && hasil && (
          <>
            {/* Peringatan ini adalah pengaman utama modul: satu salah ketik pada
                baseline atau formula dapat mengubah klaim seluruh perusahaan,
                sehingga dampaknya harus terlihat sebelum tombol Publish ditekan. */}
            {berubah > 0 ? (
              <Alert variant="danger">
                <div className="fw-bold" style={{ fontSize: "14px" }}>
                  {formatAngka(berubah, 0)} order berubah signifikan
                </div>
                <div style={{ fontSize: "12px" }}>
                  Dari {formatAngka(hasil.order_diperiksa, 0)} order yang diperiksa
                  dalam {hasil.hari} hari terakhir, perhitungan baru menghasilkan
                  selisih di atas {AMBANG_PERSEN}%. Periksa baris bertanda di bawah
                  sebelum mem-publish &mdash; perubahan ini akan berlaku pada angka
                  yang sudah pernah ditampilkan.
                </div>
              </Alert>
            ) : (
              <Alert variant="success" style={{ fontSize: "12px" }}>
                Tidak ada order yang berubah signifikan dari{" "}
                {formatAngka(hasil.order_diperiksa, 0)} order yang diperiksa dalam{" "}
                {hasil.hari} hari terakhir.
              </Alert>
            )}

            {hasil.order_diperiksa === 0 && (
              <Alert variant="warning" style={{ fontSize: "12px" }}>
                Tidak ada snapshot order pada rentang ini, sehingga dampak perubahan
                belum bisa diukur. Perluas rentang hari sebelum mengambil keputusan.
              </Alert>
            )}

            <div className="table-responsive">
              <table
                className="table table-bordered align-middle mb-0"
                style={{ fontSize: "12px" }}
              >
                <thead className="table-light">
                  <tr>
                    <th rowSpan={2}>Indikator</th>
                    <th colSpan={2} className="text-center">
                      Total
                    </th>
                    <th colSpan={2} className="text-center">
                      Rata-rata per Order
                    </th>
                    <th colSpan={2} className="text-center">
                      Selisih
                    </th>
                    <th rowSpan={2} className="text-end">
                      Order Berubah
                    </th>
                  </tr>
                  <tr>
                    <th className="text-end">Lama</th>
                    <th className="text-end">Baru</th>
                    <th className="text-end">Lama</th>
                    <th className="text-end">Baru</th>
                    <th className="text-end">Absolut</th>
                    <th className="text-end">Persen</th>
                  </tr>
                </thead>
                <tbody>
                  {perbandingan.length > 0 ? (
                    perbandingan.map((val) => (
                      <tr
                        key={val.indicator_code}
                        className={warnaDelta(val.delta_persen)}
                      >
                        <td className="fw-bold">{val.indicator_code}</td>
                        <td className="text-end">{formatAngka(val.total_lama)}</td>
                        <td className="text-end fw-bold">
                          {formatAngka(val.total_baru)}
                        </td>
                        <td className="text-end">{formatAngka(val.rata_lama, 4)}</td>
                        <td className="text-end fw-bold">
                          {formatAngka(val.rata_baru, 4)}
                        </td>
                        <td className="text-end">{formatAngka(val.delta_total)}</td>
                        <td className="text-end">
                          <Badge
                            bg={
                              Math.abs(val.delta_persen) >= AMBANG_PERSEN
                                ? "danger"
                                : "secondary"
                            }
                          >
                            {Number(val.delta_persen) > 0 ? "+" : ""}
                            {formatAngka(val.delta_persen, 2)}%
                          </Badge>
                        </td>
                        <td className="text-end">
                          {formatAngka(val.order_berubah, 0)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} align="center">
                        Tidak ada perbandingan yang dapat dihitung.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="text-muted mt-2" style={{ fontSize: "10px" }}>
              Dry-run menghitung ulang seluruh indikator aktif terhadap snapshot
              order historis, bukan hanya indikator yang sedang dibuka.
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ModalDryRun;
